var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGebietsauswahl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.023,
    height: 71.203,
    viewBox: "0 0 70.023 71.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1471",
    "data-name": "Gruppe 1471",
    transform: "translate(-1099.383 -427.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1267",
    "data-name": "Gruppe 1267",
    transform: "translate(1106.873 487.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4319",
    "data-name": "Pfad 4319",
    d: "M1131.22,648.773a5.637,5.637,0,1,1,5.637-5.637A5.644,5.644,0,0,1,1131.22,648.773Zm0-8.987a3.35,3.35,0,1,0,3.35,3.35A3.354,3.354,0,0,0,1131.22,639.786Z",
    transform: "translate(-1125.583 -637.499)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1268",
    "data-name": "Gruppe 1268",
    transform: "translate(1099.383 427.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4320",
    "data-name": "Pfad 4320",
    d: "M1105.02,439.147a5.637,5.637,0,1,1,5.637-5.637A5.644,5.644,0,0,1,1105.02,439.147Zm0-8.987a3.35,3.35,0,1,0,3.35,3.35A3.354,3.354,0,0,0,1105.02,430.16Z",
    transform: "translate(-1099.383 -427.873)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1269",
    "data-name": "Gruppe 1269",
    transform: "translate(1158.132 430.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4321",
    "data-name": "Pfad 4321",
    d: "M1310.519,447.88a5.637,5.637,0,1,1,5.637-5.637A5.644,5.644,0,0,1,1310.519,447.88Zm0-8.987a3.35,3.35,0,1,0,3.35,3.35A3.354,3.354,0,0,0,1310.519,438.893Z",
    transform: "translate(-1304.882 -436.606)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1270",
    "data-name": "Gruppe 1270",
    transform: "translate(1155.635 475.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4322",
    "data-name": "Pfad 4322",
    d: "M1301.785,605.736a5.637,5.637,0,1,1,5.637-5.637A5.644,5.644,0,0,1,1301.785,605.736Zm0-8.987a3.35,3.35,0,1,0,3.35,3.35A3.354,3.354,0,0,0,1301.785,596.749Z",
    transform: "translate(-1296.148 -594.462)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1271",
    "data-name": "Gruppe 1271",
    transform: "translate(1104.491 437.496)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2222",
    "data-name": "Rechteck 2222",
    width: 2.287,
    height: 51.232,
    transform: "matrix(0.993, -0.119, 0.119, 0.993, 0, 0.273)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1272",
    "data-name": "Gruppe 1272",
    transform: "translate(1116.619 481.079)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2223",
    "data-name": "Rechteck 2223",
    width: 41.511,
    height: 2.287,
    transform: "translate(0 10.52) rotate(-14.681)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1273",
    "data-name": "Gruppe 1273",
    transform: "translate(1160.896 440.445)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2224",
    "data-name": "Rechteck 2224",
    width: 35.8,
    height: 2.287,
    transform: "translate(0 35.759) rotate(-87.229)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1274",
    "data-name": "Gruppe 1274",
    transform: "translate(1108.37 432.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4323",
    "data-name": "Pfad 4323",
    d: "M1138.8,446.221h-.058l-6.833-.343a1.144,1.144,0,1,1,.115-2.284l6.833.343a1.144,1.144,0,0,1-.056,2.286Z",
    transform: "translate(-1130.82 -443.59)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1275",
    "data-name": "Gruppe 1275",
    transform: "translate(1121.19 433.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4324",
    "data-name": "Pfad 4324",
    d: "M1179.592,448.342h-.058l-2.785-.14a1.144,1.144,0,0,1,.115-2.284l2.785.14a1.144,1.144,0,0,1-.056,2.286Z",
    transform: "translate(-1175.662 -445.915)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1276",
    "data-name": "Gruppe 1276",
    transform: "translate(1129.514 433.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4325",
    "data-name": "Pfad 4325",
    d: "M1208.722,449.728h-.058l-2.8-.14a1.144,1.144,0,0,1,.114-2.284l2.8.14a1.144,1.144,0,0,1-.057,2.286Z",
    transform: "translate(-1204.779 -447.301)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1277",
    "data-name": "Gruppe 1277",
    transform: "translate(1137.998 433.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4326",
    "data-name": "Pfad 4326",
    d: "M1255.735,452.087h-.058l-20.133-1.01a1.144,1.144,0,0,1,.114-2.284l20.133,1.01a1.144,1.144,0,0,1-.056,2.286Z",
    transform: "translate(-1234.457 -448.789)",
    fill: "#00467d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1278",
    "data-name": "Gruppe 1278",
    transform: "translate(1120.967 442.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4327",
    "data-name": "Pfad 4327",
    d: "M1189.457,517.261c-.561,0-.62,0-2.989-2.716-1.153-1.322-2.9-3.4-4.673-5.815-4.586-6.238-6.911-11.292-6.911-15.021a14.574,14.574,0,0,1,29.148,0c0,8.612-9.307,18.794-13.43,22.88v.672Zm0-35.839a12.3,12.3,0,0,0-12.287,12.287c0,6.476,9.293,17.538,12.3,20.779,4.112-4.147,12.277-13.325,12.277-20.779A12.3,12.3,0,0,0,1189.457,481.422Z",
    transform: "translate(-1174.883 -479.135)",
    fill: "#00c713"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1279",
    "data-name": "Gruppe 1279",
    transform: "translate(1129.653 451.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4328",
    "data-name": "Pfad 4328",
    d: "M1211.556,524.394a6.289,6.289,0,1,1,6.289-6.289A6.3,6.3,0,0,1,1211.556,524.394Zm0-10.292a4,4,0,1,0,4,4A4.007,4.007,0,0,0,1211.556,514.1Z",
    transform: "translate(-1205.266 -511.815)",
    fill: "#00467d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGebietsauswahl);
export default __webpack_public_path__ + "static/media/Gebietsauswahl.c35d2332e86cea036d9d0caae0657051.svg";
export { ForwardRef as ReactComponent };